import util from '../utils/index';
let routerList = [
    {
        path: 'panel',
        name: 'panel',
        component: () => import(/* webpackChunkName: "port" */ "../views/panel/index"),
        meta:{
            bread:false,
        }
    },
    {
        path: 'profile',
        name: 'profile',
        component: () => import(/* webpackChunkName: "port" */ "../views/profile/index"),
        meta:{
            bread:false,
        }
    },
    {
        path: 'password',
        name: 'password',
        component: () => import(/* webpackChunkName: "port" */ "../views/password/index"),
        meta:{
            bread:false,
        }
    },
    {
        path: 'actas',
        name: 'actas',
        component: () => import(/* webpackChunkName: "port" */ "../views/actas/index"),
        meta:{
            bread:false,
        }
    },
    {
        path: 'sercurity',
        name: 'sercurity',
        component: () => import (/* webpackChunkName: "sercurity" */ "../views/sercurity/index"),
        meta: {
            bread: false
        }
    },
    {
        path: "",
        redirect: { name: "panel" }
    },
    {
        path: 'connections',
        name: 'connections',
        component: () => import(/* webpackChunkName: "port" */ "../views/connections/index"),
        meta:{
            bread:false,
        }
    },
]
// 检测是否展示社交登录
if (!util.checkSocialLogin(window.location.host)) {
    routerList.splice(routerList.length - 1, 1);
}

export default routerList;
